export const WEB_HOOK = {
  PAY_OUT: 1,
  STATIC_CODE: 2,
  DYNAMIC_ORDER: 3,
  STATIC_VA: 4
}

export const GULF_USD_ONLY_COUNTRY_CODES = ['AE', 'SA', 'QA', 'KW', 'OM', 'BH']

export const LARGE_VALUE_PAYMENT_COUNTRY_CODES = ['PH', 'TH', 'AE', 'SA', 'VN']
